<template>
  <v-container fluid>
    <v-btn color="primary" dark class="mb-2" @click="addEntry">
      New Resource
    </v-btn>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card class="pb-3">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <v-card-title class="primary">
            <span class="headline white--text">Dealer Login Resources</span>
          </v-card-title>
          <v-card-text class="pb-0 pt-2">
            <v-form v-model="valid" lazyValidation>
              <v-container class="pa-0" grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 class="pa-0">
                    <ValidationProvider
                      name="Category"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-combobox
                        v-model="editedItem.category"
                        :items="Array.from(rows, x => x.category)"
                        label="Category"
                        :error-messages="errors"
                      ></v-combobox>
                    </ValidationProvider>
                  </v-flex>

                  <v-flex xs12 class="pa-0">
                    <ValidationProvider
                      name="Section"
                      v-slot="{ errors }"
                    >
                      <!-- rules="required" -->
                      <v-combobox
                        v-model="editedItem.section"
                        :items="dialog ? [...rows].map(x => x.section) : []"
                        label="Section"
                        :error-messages="errors"
                        class="mt-0 pt-1"
                      ></v-combobox>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 class="pa-0">
                    <ValidationProvider
                      name="Type"
                      :rules="editedItem.type ? 'required' : ''"
                      v-slot="{ errors }"
                    >
                      <v-combobox
                        v-model="editedItem.type"
                        :items="dialog ? [...rows].map(x => x.type) : []"
                        label="Type"
                        :error-messages="errors"
                        class="mt-0 pt-1"
                      ></v-combobox>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 class="pa-0">
                    <ValidationProvider
                      name="Label"
                      :rules="editedItem.label ? 'required' : ''"
                      v-slot="{ errors }"
                    >
                      <v-combobox
                        v-model="editedItem.label"
                        :items="dialog ? [...rows].map(x => x.label) : []"
                        label="Label"
                        :error-messages="errors"
                        class="mt-0 pt-1"
                      ></v-combobox>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 class="pa-0">
                    <ValidationProvider
                      name="file"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        name="file"
                        v-model="editedItem.file"
                        label="File"
                        :error-messages="errors"
                        class="mt-0 pt-1"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 class="pa-0">
                    <ValidationProvider
                      name="Link"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        name="link"
                        v-model="editedItem.href"
                        label="Link"
                        :error-messages="errors"
                        class="mt-0 pt-1"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex class="pa-0">
                    <v-checkbox
                      name="archived"
                      v-model="editedItem.archived"
                      label="Archived"
                      class="mt-0"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <message-alert :component="message"></message-alert>
          </v-card-text>
          <v-card-actions class="px-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="invalid"
              class="mr-2"
              @click.native="save"
            >
              Save
            </v-btn>
            <v-btn color="light-grey" @click.native="close">Cancel</v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>

    <div>
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-checkbox
            name="showArchived"
            v-model="showArchived"
            label="Show Archived"
            @change="getDataFromApi"
          ></v-checkbox>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :total-items="totalItems"
      :pagination.sync="pagination"
      :items="filteredRows"
      :headers="headers"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="(prop, propIndex) in headers.filter(x => x.text != 'Actions')"
          :key="propIndex"
          :class="'ma-0'"
        >
          <div v-if="prop.autocomplete" :class="'text-xs-' + prop.align">
            {{ props.item[prop.value][prop.nested] }}
          </div>

          <div v-else :class="'text-xs-' + prop.align">
            {{ props.item[prop.value] }}
          </div>
        </td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-flex sm12 md12 lg12>
      <message-alert :component="message"></message-alert>
    </v-flex>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import {
  mapDealerPortalFields,
  mapDealerPortalMultiRowFields,
} from '@/store/modules/orders';

const {
  mapActions: mapDealerPortalActions,
  mapMutations: mapDealerPortalMutations,
} = createNamespacedHelpers(`orders/dealerPortal`);
import { httpError } from '@/models/httpError';
import { ResourceFile } from '@/models/ResourceFile';

export default {
  name: 'maintainResources',
  data: () => ({
    valid: true,
    dialog: false,
    editedItem: new ResourceFile(),
    editedIndex: 0,
    SearchText: null,
    items: [],
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
    },
    loading: false,

    headers: [
      {
        text: 'Category',
        align: 'left',
        sortable: true,
        value: 'category',
      },
      {
        text: 'Section',
        align: 'left',
        sortable: true,
        value: 'section',
      },
      {
        text: 'Type',
        align: 'left',
        sortable: true,
        value: 'type',
      },
      {
        text: 'Label',
        align: 'left',
        sortable: true,
        value: 'label',
      },
      {
        text: 'File',
        align: 'left',
        sortable: true,
        value: 'file',
      },
      {
        text: 'Link',
        align: 'left',
        sortable: true,
        value: 'href',
      },
      {
        text: 'Actions',
        align: 'center',
        sortable: false,
      },
    ],
    showArchived: false,
  }),

  computed: {
    ...mapDealerPortalFields(['message']),
    ...mapDealerPortalMultiRowFields(['rows']),

    filteredRows: function() {
      let vm = this;
      return vm.rows.filter(this.isValid);
    },
  },

  methods: {
    ...mapDealerPortalActions([
      'getResourceFiles',
      'saveResourceFile',
      'removeRows',
      'setMessage',
      'addResource',
      'deleteRow',
    ]),
    ...mapDealerPortalMutations(['addRow']),
    addOption(val, payload) {
      this[val].push('New');
    },
    addEntry() {
      let vm = this;
      vm.setMessage(new httpError());
      vm.addResource().then(data => {
        vm.editedIndex = data;
        vm.editedItem = vm.rows[data];
        vm.dialog = true;
      });
    },
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        vm.getResourceFiles(vm.showArchived).then(items => {
          const total = items.count;

          vm.loading = false;
          resolve({
            items,
            total,
          });
        });
      });
    },

    editItem(item) {
      this.setMessage(new httpError());
      this.editedIndex = this.rows.indexOf(item);
      this.editedItem = this.rows[this.editedIndex];
      this.dialog = true;
    },

    deleteItem(item) {
      this.setMessage(new httpError());
      const index = this.rows.indexOf(item);
      let answer = confirm('Are you sure you want to delete this item?');
      if (answer) {
        this.removeRows(index).then(data => {
          //this.items.splice(index, 1);
        });
      }
    },

    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter(x => x.sortable).map(x => x.value);

      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },

    close() {
      let vm = this;
      vm.dialog = false;
      setTimeout(() => {
        vm.deleteRow();
        vm.editedItem = Object.assign({}, new ResourceFile());
        vm.editedIndex = -1;
        vm.getDataFromApi();
      }, 300);
    },

    save() {
      let vm = this;
      vm.saveResourceFile(vm.editedIndex)
        .then(() => vm.close())
        .catch(() => vm.close());
    },
  },
  mounted() {
    let vm = this;
    this.$nextTick(() => {
      vm.getDataFromApi();
    });
  },
};
</script>
